// extracted by mini-css-extract-plugin
export default {"enterWordQuiz":"QuizEnterWord_enterWordQuiz__Dq0fM","question":"QuizEnterWord_question__S8hb1","img":"QuizEnterWord_img__paCBl","mobileInput":"QuizEnterWord_mobileInput__Ao6zk"};